import React from 'react';
import { IBoxProps } from '@styleseat/ui';
import {
  useMount,
  useParams,
  useRouteName,
} from '../../../../hooks';
import analytics from '../../../../modules/analytics';
import { openExternalUrl } from '../../../../modules/openExternalUrl';
import { IProviderClient } from '../../../../api/Providers/Clients/types';
import EmptyClientList from './EmptyClientList';
import { useAddClientHandler, useBulkImportHandler } from '../hooks';

const ITERATION_KEY = 'add-upload-secure-012018';

/**
 * Track clicks to add client methods
 * @param   {String} method 'add-client-button', 'bulk-import', 'upload-zendesk'
 * @returns {undefined}
 */
function trackAddClientClick(method: string, source: string) {
  const params = {
    pro_add_clients_method: method,
    pro_add_client_source: ITERATION_KEY,
    source: source || 'Client Empty State',
  };
  analytics.track('P Clicked Add New Client', params);
}

type EmptyClientListContainerProps = {
  providerId: number;
  style?: IBoxProps['style'],
  onNewClientSaved?: (newClient: IProviderClient) => void;
};

export const EmptyClientListContainer: React.FC<EmptyClientListContainerProps> = ({
  providerId,
  style,
  onNewClientSaved,
}) => {
  const { source } = useParams();
  const [routeName] = useRouteName();

  useMount(() => {
    analytics.track('P Saw Client Empty State', {
      client_empty_state_version: ITERATION_KEY,
      source,
    });
  });

  const handleBulkImportClick = useBulkImportHandler(routeName, source);

  const {
    Component: AddClient,
    handler: handleAddClientClick,
  } = useAddClientHandler(source, onNewClientSaved);

  const handleLaunchEmail = () => {
    trackAddClientClick('email-client-list', source);
    openExternalUrl(`mailto:cx@styleseat.com?subject=Pro request - import client list, ProID: ${providerId}`, '_system');
  };

  return (
    <React.Fragment>
      <EmptyClientList
        providerId={providerId}
        style={style}
        bulkImportClick={handleBulkImportClick}
        addClientClick={handleAddClientClick}
        launchEmail={handleLaunchEmail}
      />
      <AddClient />
    </React.Fragment>
  );
};
